module.exports = __webpack_public_path__ + "media/video.0dbab708.mp4";